import React from 'react';
import StaticPageLayout, { StaticSection } from '../components/StaticPageLayout.jsx';

const FAQ_ITEMS = [
  {
    title: 'Démarrer l\'application',
    body: 'Vous pouvez commencer sans créer de compte classique. Il suffit de créer un foyer ou de rejoindre un foyer existant avec un code d\'invitation, puis de définir votre code secret personnel.'
  },
  {
    title: 'Inviter mon ou ma partenaire',
    body: 'Une fois votre foyer créé, un code d\'invitation est généré. Partagez ce code ou le lien correspondant depuis l\'écran d\'accueil afin que votre partenaire puisse rejoindre le même foyer.'
  },
  {
    title: 'Retrouver mon accès',
    body: 'Votre accès repose sur votre code secret personnel. Si vous avez ajouté une adresse email de récupération, vous pouvez aussi utiliser le lien de reconnexion par email lorsqu\'il est disponible.'
  },
  {
    title: 'Comprendre le questionnaire et les statistiques',
    body: 'Le questionnaire se remplit par thèmes. Des premiers résultats deviennent visibles dès qu\'un premier thème est terminé. Les statistiques évoluent ensuite à mesure que vous complétez davantage de catégories.'
  },
  {
    title: 'Signaler un problème ou demander la suppression de mes données',
    body: 'Si vous rencontrez un bug, un problème d\'accès, ou si vous souhaitez demander la suppression de vos données, utilisez le canal de support associé au service ou à la fiche de l\'application.'
  }
];

export default function SupportPage() {
  return (
    <StaticPageLayout
      eyebrow="Assistance"
      title="Centre d'assistance"
      description="Quelques réponses rapides pour aider à démarrer, retrouver son accès et comprendre le fonctionnement général de l'application."
      lastUpdated="Mars 2026"
    >
      <StaticSection title="Questions fréquentes">
        <div className="space-y-3">
          {FAQ_ITEMS.map((item) => (
            <details
              key={item.title}
              className="group rounded-[24px] border border-ptcm-border bg-ptcm-surface/85 p-5"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4">
                <span className="text-base font-semibold text-ptcm-ink">{item.title}</span>
                <span className="text-xl leading-none text-ptcm-muted transition-transform group-open:rotate-45">+</span>
              </summary>
              <p className="mt-3 text-sm leading-7 text-ptcm-muted">{item.body}</p>
            </details>
          ))}
        </div>
      </StaticSection>

      <StaticSection title="Bonnes pratiques">
        <p>
          Pour obtenir des résultats utiles, répondez chacun de votre côté, sans vous consulter,
          en pensant à une semaine type. Vous pouvez avancer progressivement et revenir plus tard
          sur les catégories non terminées.
        </p>
        <p>
          Si vous partagez le même appareil, veillez à conserver votre propre code secret et à ne
          pas le communiquer.
        </p>
      </StaticSection>
    </StaticPageLayout>
  );
}
